import React, { useContext, useEffect, useState } from 'react';
import msg from '../Tools/MsgUtils';
import { ReactSession } from "react-client-session";
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ReporteProductos() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [producto, setProducto] = useState('');
    const [listaProductos, setListaProductos] = useState([]);
    const [listaSucursal, setListaSucursal] = useState([]);
    const [sucursal, setSucursal] = useState(-1);
    const [busquedas, setBusquedas] = useState([]);
    function actualizarLista() {
        if (busquedas.length !== 0) {
            fetch(`${server}/reporte/buscarProducto`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: '990',
                    busquedas,
                    sucursal
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.ok) {
                        setListaProductos(data.ok);
                    } else {
                        msg.msgError(data.message);
                    }
                })
                .catch(error => msg.msgError(error));
        } else {
            setLoading(false);
            msg.msgError("Agregue lo que decea Buscar !!");
        }
    }
    const seleccionarSucursal = (e) => {
        setListaProductos([]);
        setSucursal(e.target.value);
    }
    const getProducto = (e) => {
        setProducto(e.target.value);
        setListaProductos([]);
    }
    const eliminarFiltro = (e) => {
        console.log(e.target.id)
        var nuevoFiltro = busquedas.filter((item) => item.ID != e.target.id);
        setBusquedas(nuevoFiltro);
    }
    const agregarFiltro = () => {
        var isFiltro = busquedas.length;
        if (producto !== '') {
            setBusquedas([...busquedas, { 'ID': isFiltro, 'NOMBRE': producto }]);
        } else {
            msg.msgError("Escriba lo que quiere buscar !!")
        }
    }
    useEffect(() => {
        if (producto !== '') {
            actualizarLista();
        }
    }, [sucursal]);
    useEffect(() => {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: ReactSession.get("regional")
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setListaSucursal(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }, []);
    return (
        <div>
            <div className='bg-dark bg-gradient container-fluid'>
                <div className='row row-cols-1 row-cols-md-2 g-0'>
                    <div className='col col-md-4 my-auto'>
                        <div className="text-end py-1">
                            <div className="input-group input-group-sm">
                                <input className="form-control form-control-sm border-end-0 border "
                                    type="search"
                                    id="example-search-input"
                                    placeholder='Buscar Producto'
                                    value={producto}
                                    onChange={getProducto} />
                                <div className='btn-group btn-group-sm'>
                                    <button className='btn btn-sm btn-success fs-6' 
                                        id='btnAgregarProducto'
                                        onClick={agregarFiltro}><i className="fa-solid fa-circle-plus"></i></button>
                                    <button className='btn btn-secondary btn-sm p-0 m-0' 
                                        disabled={busquedas.length==0?true:false}
                                        onClick={() => { setLoading(true); actualizarLista() }}><i className="fa-solid fa-magnifying-glass"></i>Buscar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid bg-dark bg-gradient'>
                <div className='row row-cols-1 row-cols-md-2 g-0'>
                    <div className='col col-md-1'>
                        <div className="forms-inputs forms-inputs-sm">
                            <span className='text-light'>Sucursal</span>
                            <select className="form-select btn btn-secondary btn-sm text-start" value={sucursal} onChange={seleccionarSucursal}>
                                <option value='-1'>--TODAS--</option>
                                {listaSucursal.map((item, i) => {
                                    return <option value={item.ID_SUCURSAL} key={item.ID_SUCURSAL}>{item.SUCURSAL}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col col-md-11 my-auto m-0 p-0'>
                        <div className='btn-group m-0 p-0'>
                            {busquedas.map((item, index) => {
                                return (
                                    <div className='btn text-start' key={index}>
                                        <span className="badge bg-secondary position-relative">
                                            {item.NOMBRE}
                                            <a className="btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                id={item.ID}
                                                onClick={eliminarFiltro}>
                                                X
                                            </a>
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {loading === false &&
                <div className='container-fluid py-2 table-responsive'>
                    <table className="table table-sm table-striped table-hover">
                        <thead>
                            <tr>
                                <th scope="col">DESCRIPCION</th>
                                <th scope="col">ALMACEN</th>
                                <th scope="col">STOCK</th>
                                <th scope="col">UNIDAD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaProductos.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{item.DESCRIPCION}</td>
                                        <td>{item.NOMBRE_ALMACEN}</td>
                                        <td>{item.STOCK.toFixed(2)}</td>
                                        <td>{item.UNIDADES}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

export default ReporteProductos
